import { Navigate, useLocation, useParams, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()
  const { lang } = useParams<{ lang: string }>()

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <div className='flex items-center space-x-2'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent' />
          <span className='text-sm text-muted-foreground'>Loading...</span>
        </div>
      </div>
    )
  }
  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated()) {
    return <Navigate to={`/${lang}/login`} state={{ from: location }} replace />
  }

  // If authenticated, render the protected content
  return <Outlet />
}

export default ProtectedRoute
